// src/components/reports/SummaryReportModal.js

import React from 'react';
import { X, Download, FileText, Eye } from 'lucide-react'; 
import toast from 'react-hot-toast';
import { generateReportPDF } from './ReportGenerator'; 

const SummaryReportModal = ({ 
    isOpen, 
    onClose, 
    summary, 
    timeEntries, 
    properties, 
    selectedProperty, 
    dateFilter, 
    customDate,
    payrollData,
    user
}) => {
    if (!isOpen) return null;

    const currentProperty = properties.find(p => p.id === parseInt(selectedProperty));

    // Handler for Downloading
    const handleDownload = (type) => {
        const doc = generateReportPDF(type, {
            summary, 
            timeEntries, 
            currentProperty, 
            dateFilter, 
            customDate,
            payrollData,
            user
        });

        if (doc) {
            const reportName = type === 'WORK_ONLY' ? 'Work_Logs' : type === 'PAYROLL_ONLY' ? 'Payroll_Statement' : 'Summary_Report';
            doc.save(`${reportName}_${new Date().toISOString().slice(0,10)}.pdf`);
            toast.success("Report Downloaded");
            onClose();
        }
    };

    // Handler for Previewing
    const handlePreview = (type) => {
        const doc = generateReportPDF(type, {
            summary, 
            timeEntries, 
            currentProperty, 
            dateFilter, 
            customDate,
            payrollData,
            user
        });

        if (doc) {
            const pdfBlob = doc.output('blob');
            const blobUrl = URL.createObjectURL(pdfBlob);
            window.open(blobUrl, '_blank');
        }
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{ maxWidth: '500px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FileText size={24} className="text-primary" />
                        Export Report
                    </h2>
                    <button onClick={onClose} className="icon-button"><X size={20} /></button>
                </div>
                
                <p style={{ color: '#64748b', marginBottom: '20px' }}>
                    Select the type of report you would like to generate for <strong>{currentProperty ? currentProperty.name : 'All Properties'}</strong>.
                </p>

                {payrollData && (
                    <div style={{ 
                        backgroundColor: '#f0f9ff', 
                        border: '1px solid #bae6fd', 
                        padding: '10px', borderRadius: '6px', marginBottom: '20px', fontSize: '0.9em', color: '#0369a1'
                    }}>
                        <strong>Payment Statements:</strong> {payrollData.status}
                    </div>
                )}

                <div className="modal-actions" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {/* --- Summary Report Actions --- */}
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button 
                            onClick={() => handlePreview('COMBINED')} 
                            className="button button-secondary" 
                            title="Preview Summary Report"
                            style={{
                                flex: 1, 
                                display:'flex', 
                                justifyContent:'center', 
                                alignItems:'center', 
                                height:'48px'
                            }}
                        >
                            <Eye size={24} />
                        </button>

                        <button 
                            onClick={() => handleDownload('COMBINED')} 
                            className="button action-button" 
                            title="Download Summary Report"
                            style={{
                                flex: 1, 
                                display:'flex', 
                                justifyContent:'center', 
                                alignItems:'center', 
                                height:'48px'
                            }}
                        >
                            <Download size={24} />
                        </button>
                    </div>
                </div>
                
                {!payrollData && (
                    <p style={{textAlign:'center', fontSize:'0.8rem', color:'#94a3b8', marginTop:'10px'}}>
                        * Payment Statement data is not included as no statement exists for this period.
                    </p>
                )}

                {/* --- NEW: Branding Footer (Opens in New Tab) --- */}
                <div style={{
                    marginTop: '25px',
                    paddingTop: '15px',
                    borderTop: '1px solid #f1f5f9',
                    textAlign: 'center',
                    fontSize: '0.75rem',
                    color: '#94a3b8'
                }}>
                    Product of{' '}
                    <a 
                        href="https://thewesterntech.com/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#1798c1', textDecoration: 'none', fontWeight: '600' }}
                    >
                        The WesternTech
                    </a>
                </div>

            </div>
        </div>
    );
};

export default SummaryReportModal;